module.exports = __webpack_public_path__ + "img/error-skill-eval.13307eb0.svg";